<template>
    <div v-if="isStockStorage">
        <CustomDataGrid :hasIndexGroup="false" :items="items" :headers="[
            { dataField: 'obra', caption: 'Obra' },
            { dataField: 'ubicacion', caption: 'Ubicacion' },
            { dataField: 'familia', caption: 'Familia' },
            { dataField: 'referencia', caption: 'Referencia' },
            { dataField: 'descripcion', caption: 'Descripcion' },
            // { dataField: 'precio_compra', caption: 'Precio compra' },
            { dataField: 'stock', caption: 'Stock' },
            { dataField: 'embalaje', caption: 'Embalaje' },
            { dataField: 'unidades_caja', caption: 'Unidades caja' },
            { dataField: 'seriado', caption: 'Seriado' },
        ]" />
    </div>
    <div v-else>
         <CustomDataGrid :hasIndexGroup="true" :items="items" :headers="[
            { dataField: 'brigada', caption: 'Brigada', group: 0 },
            { dataField: 'obra', caption: 'Obra' },
            { dataField: 'nombrefamilia', caption: 'Familia' },
            { dataField: 'referencia', caption: 'Referencia' },
            { dataField: 'descripcion', caption: 'Descripcion' },
            // { dataField: 'precio_compra', caption: 'Precio compra' },
            { dataField: 'stock', caption: 'Stock' },
        ]" />
    </div>
</template>

<script>
import {
//   DxDataGrid,
//   DxPaging,
//   DxColumn,
//   DxSearchPanel,
//   DxFilterRow,
//   DxHeaderFilter,
//   DxPager,
//   DxOperationDescriptions,
} from "devextreme-vue/data-grid";
import CustomDataGrid from './CustomDataGrid.vue';
export default {
    components: {
        // DxDataGrid,
        // DxPaging,
        // DxColumn,
        // DxSearchPanel,
        // // DxOperationDescriptions,
        // DxFilterRow,
        // DxHeaderFilter,
        // DxPager,
        CustomDataGrid,
    },
    data() {
        return {
            pageSizes: [15, 30, 50],
            texts: {
                editRow: "Editar",
                saveRowChanges: "Guardar",
                saveAllChanges: "Guardar cambios",
                deleteRow: "Eliminar",
                cancelRowChanges: "Cancelar",
                confirmDeleteTitle: "Información",
                confirmDeleteMessage: "¿Realmente desea eliminar el registro?",
                cancelAllChanges: "Descartar cambios",
            },
        };
    },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        isStockStorage: {
            type: Boolean,
            default: () => false,
        },
    },
};
</script>